module.exports = __webpack_public_path__ + "static/show_blank_line_between_items_example-5ef64324fd76cda43bb5ef6d7efc818f.png";